export default ['action', 'index', 'offsetdays', 'actionWorkingDay'];
